import Banner from '@components/Banner/banner';
import AboutUsOne from './sections/AboutUsOne';
import AboutUsTwo from './sections/AboutUsTwo';
import Footer from '@components/Footer/Footer';
import { useTranslation } from 'react-i18next';

function AboutUs() {
  const { t } = useTranslation('aboutUs');
  return (
    <>
      <Banner
        title={
          <>
            <span style={{ display: 'inline-block', marginBottom: '20px' }}>
              {t('aboutUs.title')}
            </span>
          </>
        }
        paragraph={
          <>
            {t('aboutUs.subtitle.spanBefore')}
            <span style={{ color: '#F16024' }}>2</span>{' '}
            {t('aboutUs.subtitle.spanAfter')}
          </>
        }
      />
      <AboutUsOne />
      <AboutUsTwo />
      <Footer />
    </>
  );
}

export default AboutUs;
